/**
 * @generated SignedSource<<bfd4e2d85b9a7860a961322a595f9d1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
  };
  readonly " $fragmentType": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge";
}>;
export type contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "contentUtilitiesGetEntityIdsByQueueItemQueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "2d2f8fdbefca1f05ad1a59212ef73c0d";

export default node;
